'use strict';
import * as $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dPermission from "./app.data.-General-Practice-User-Permission.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_GeneralPracticeUserPermission$RemoveUser(role) {
  this.Lapp_data_GeneralPracticeUserPermission$RemoveUser__f_role = null;
  this.Lapp_data_GeneralPracticeUserPermission$RemoveUser__f_role = role;
}
export { $c_Lapp_data_GeneralPracticeUserPermission$RemoveUser as $c_Lapp_data_GeneralPracticeUserPermission$RemoveUser };
$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype = new $j_app$002edata$002e$002dGeneral$002dPractice$002dUser$002dPermission.$h_Lapp_data_GeneralPracticeUserPermission();
$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype.constructor = $c_Lapp_data_GeneralPracticeUserPermission$RemoveUser;
/** @constructor */
function $h_Lapp_data_GeneralPracticeUserPermission$RemoveUser() {
}
export { $h_Lapp_data_GeneralPracticeUserPermission$RemoveUser as $h_Lapp_data_GeneralPracticeUserPermission$RemoveUser };
$h_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype = $c_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype;
$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-507017503), true);
});
$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_GeneralPracticeUserPermission$RemoveUser)) {
    var x = this.Lapp_data_GeneralPracticeUserPermission$RemoveUser__f_role;
    var x$2 = x$0.Lapp_data_GeneralPracticeUserPermission$RemoveUser__f_role;
    return (x === x$2);
  } else {
    return false;
  }
});
$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype.productPrefix__T = (function() {
  return "RemoveUser";
});
$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_GeneralPracticeUserPermission$RemoveUser__f_role;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "role";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_GeneralPracticeUserPermission$RemoveUser.prototype.ordinal__I = (function() {
  return 4;
});
function $isArrayOf_Lapp_data_GeneralPracticeUserPermission$RemoveUser(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_GeneralPracticeUserPermission$RemoveUser)));
}
export { $isArrayOf_Lapp_data_GeneralPracticeUserPermission$RemoveUser as $isArrayOf_Lapp_data_GeneralPracticeUserPermission$RemoveUser };
var $d_Lapp_data_GeneralPracticeUserPermission$RemoveUser = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_GeneralPracticeUserPermission$RemoveUser, "app.data.GeneralPracticeUserPermission$RemoveUser", ({
  Lapp_data_GeneralPracticeUserPermission$RemoveUser: 1,
  Lapp_data_GeneralPracticeUserPermission: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_data_GeneralPracticeUserPermission$RemoveUser as $d_Lapp_data_GeneralPracticeUserPermission$RemoveUser };
//# sourceMappingURL=app.data.-General-Practice-User-Permission$-Remove-User.js.map
